import { apiBPRequest } from '@api/apiCall';
import { useToast } from '@hooks';
import { useNavigation } from '@react-navigation/native';
import { getStore } from '@store/storeUtils';
import { useMutation } from '@tanstack/react-query';
import { showErrorOnAPI } from '@utils/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Define types for API payload and response
type BPPayload = Record<string, any>; // Replace with the actual payload structure
type BPResponse = Record<string, any>; // Replace with the actual response structure

interface UseBPMutationProps {
  setOpenRTS: (val: boolean) => void;
  setBpReqData: (data: BPResponse) => void;
}

const useBPMutation = ({ setOpenRTS, setBpReqData }: UseBPMutationProps) => {
  const { setLoading, setInitialData } = getStore();
  const { t } = useTranslation('common');
  const toast = useToast();
  const navigation = useNavigation();
  const [apiPayload, setApiPayload] = useState<BPPayload | null>(null);

  const {
    isLoading: isBPReqLoading,
    isError: isBPReqError,
    error: bpError,
    isSuccess: isBPSuccess,
    data: bpData,
    mutate: requestBP,
  } = useMutation<BPResponse, unknown, BPPayload>({
    mutationFn: payload => {
      setApiPayload(payload);
      return apiBPRequest(payload);
    },
  });

  useEffect(() => {
    setLoading(isBPReqLoading);
  }, [isBPReqLoading]);

  useEffect(() => {
    if (isBPSuccess && bpData) {
      setBpReqData(bpData);
      setOpenRTS(true);
    }
  }, [isBPSuccess, bpData, setBpReqData, setOpenRTS]);

  useEffect(() => {
    showErrorOnAPI(isBPReqError, bpError, toast, t, navigation, setInitialData);
  }, [isBPReqError, bpError, navigation, setInitialData]);

  return {
    requestBP,
    isBPReqLoading,
    isBPReqError,
    bpError,
    isBPSuccess,
    bpData,
    apiPayload,
  };
};

export default useBPMutation;
